<template>
    <div class="ma-4">
        <div class="display-1 mb-3">
            {{$t('userStatistic') | capitalize}}
        </div>
        <v-text-field
            v-model="keySearch"
            :placeholder="$t('salePage.searchDescription')"
        ></v-text-field>
        <SimpleDataTable
            :headers="headers"
            :items="dataTable"
            :pagination.sync="pagination"
            @row-click="select($event)"
        >
        </SimpleDataTable>
        <UserStatisticDetail ref="UserStatisticDetail"></UserStatisticDetail>
    </div>
</template>
<script>
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'
import StatisticService from '@/services/statistic.service'
import UserStatisticDetail from '@/views/Analytics/UserStatisticDetail'
import BaseStatistic from '@/views/Analytics/BaseStatistic'

export default {
    name: 'UserStatistic',
    components: { SimpleDataTable, UserStatisticDetail },
    extends: BaseStatistic,
    data () {
        return {
            searchErrorMessageKey: 'canNotSearchUser',
            detailKey: 'UserStatisticDetail'
        }
    },
    computed: {
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'name'
                },
                {
                    text: this.$t('phone'),
                    value: 'phone'
                },
                {
                    text: this.$t('email'),
                    value: 'email'
                },
                {
                    text: this.$t('project') + ' (' +
                        this.$t('prepaid') + ' | ' +
                        this.$t('postpaid') + ')',
                    value: 'numberOfProject',
                    $value: item => item.project_prepaid_count + ' | ' + item.project_postpaid_count
                },
                {
                    text: this.$t('createdTime'),
                    value: 'created_time',
                    $value: item => this.$filters.formatDateTime(item.created_time)
                },
                {
                    text: this.$t('lastApiCallTime') + ' (12 ' + this.$t('month') + ')',
                    value: 'lastActiveTime',
                    $value: item => this.$filters.formatDateTime(item.last_active)
                }
            ])
        }
    },
    methods: {
        getSearchPromise () {
            return StatisticService.searchUser(this.keySearch, this.pagination)
        }
    }
}
</script>
